import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import { computed } from "mobx";
import MinistryOfFinanceReportsListViewModel from "./ministryOfFinanceReportsListViewModel";

const navigationName = "ministry-of-finance";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [MinistryOfFinanceReportsListViewModel],
})
export default class MinistryOfFinanceReportsViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private localizationService: LocalizationService,
    private ministryOfFinanceReportsListViewModel: MinistryOfFinanceReportsListViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(this.ministryOfFinanceReportsListViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `externalReports.${code}`, size);
  }

  @computed
  get name() {
    return this.translate("name");
  }
}
